import SensorDisplay from "./SensorDisplay";

export default function SensorGroups({
  groups,
  sensors,
  updateSelectedForBarGraph,
}) {
  return (
    <div>
      {groups.map((g) => (
        <div key={g.id} className="sectionSpacer">
          <div className="pumpRoomSection">
            <h2>{g.name}</h2>
            {sensors
              .filter((s) => s.group === g.id)
              .map((s) => (
                <SensorDisplay
                  key={s.id}
                  sensor={s}
                  updateSelectedForBarGraph={updateSelectedForBarGraph}
                />
              ))}
          </div>
        </div>
      ))}
    </div>
  );
}
